import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "layout-body" }

import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import CLoading from '@/components/common/CLoading.vue'
import {
  useLayoutStore,
  useCameraFrameStore,
  useConfAndQueryStore,
  useProductStore,
  useStackingStore
} from '@/store'
import TryOnCameraFrame from '@/components/all-works/TryOnCameraFrame.vue'
import NewWorks from '@/views/NewWorks.vue'
import AllWorks from '@/views/AllWorks.vue'
import { delay, throttle } from '@/utils'
import { storeToRefs } from 'pinia'
import { preloadImages } from '@/hooks/use-image'
import useScreen from '@/hooks/use-screen'
import Footer from './Footer.vue'
import useAlert from '@/hooks/use-alert'
import CAlert from '@/components/common/CAlert.vue'
import { isAndroid, isIOS } from '@/utils/device'
import { ClickAction } from '@/data/report'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { rootScale } = useScreen()
const layoutStore = useLayoutStore()
const productStore = useProductStore()
const stackingStore = useStackingStore()
const {
  isTryOnCameraRendered,
  isDefaultCameraRendered,
  isAllWorksMode,
  isAllWorksReady,
  isFromNewWorksToTryOn,
  hasManualLoading
} = storeToRefs(layoutStore)
const cameraFrameStore = useCameraFrameStore()
const { isCameraLoading } = storeToRefs(cameraFrameStore)
const { alertState, hasAlertShown } = useAlert()
const confAndQueryStore = useConfAndQueryStore()

const initializing = ref(true)
const isLoading = computed(() => {
  console.log('[[ Layout ] Loading Condition ]', {
    initializing: initializing.value,
    allWorksMode: isAllWorksMode.value,
    cameraLoading: isCameraLoading.value,
    manualLoading: hasManualLoading.value
  })
  return (
    initializing.value ||
    (isAllWorksMode.value && (isCameraLoading.value || hasManualLoading.value))
  )
})

const style = computed(() => {
  const radius = Math.round(40 * rootScale.value) / 2
  return {
    '--layout-scale': rootScale.value,
    '---layout-scale': rootScale.value * -1,
    '--tab-swiper-delay':
      isAllWorksMode.value && isFromNewWorksToTryOn ? '0.24s' : '0s',
    '--deco-radius': `${radius}px`,
    '--cate-radius': `${radius - 6}px`,
    '--deco-width': `${radius * 2}px`
  }
})

const closeAlert = throttle(() => {
  confAndQueryStore.report(
    ClickAction.CANCEL_ALERT,
    alertState.value.reportValue
  )
  alertState.value.onClose()
})

const confirmAlert = throttle(() => {
  if (typeof alertState.value.onConfirm === 'function') {
    if (alertState.value.reportValue === 'Camera_Access_Denied') {
      confAndQueryStore.report(ClickAction.RELOAD_PAGE)
    }
    alertState.value.onConfirm()
  } else {
    confAndQueryStore.report(
      ClickAction.CLOSE_ALERT,
      alertState.value.reportValue
    )
    alertState.value.onClose()
  }
})

const triggerOtherAction = throttle(() => {
  alertState.value.otherAction?.()
})

const loadingUsable = ref(true)
watch(hasAlertShown, async () => {
  if (hasAlertShown.value) {
    await delay(300)
    loadingUsable.value = false
  } else {
    loadingUsable.value = true
  }
})

onMounted(async () => {
  window.addEventListener('message', cameraFrameStore.onReceiveIframeMessage)
  // console.log('[[ Selection ] Init Products And Stackings ]')
  productStore.initProducts()
  stackingStore.initStackingsAndProducts()
  await Promise.all([
    delay(1000),
    preloadImages([...confAndQueryStore.images]).then(() => {
      // console.log('[[ Layout ] Preload Image ]', {
      //   count: confAndQueryStore.images.length
      // })
    })
  ])
  initializing.value = false
})
onUnmounted(() => {
  window.removeEventListener('message', cameraFrameStore.onReceiveIframeMessage)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["layout font-14", { 'is-ios': _unref(isIOS), 'is-android': _unref(isAndroid) }]),
      style: _normalizeStyle(style.value)
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_unref(isTryOnCameraRendered) || _unref(isDefaultCameraRendered))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass({
          workspace: true,
          'all-works-and-camera': true,
          hidden: !_unref(isAllWorksReady) || _unref(hasAlertShown),
          'switch-instant': _unref(hasAlertShown)
        })
            }, [
              (_unref(isTryOnCameraRendered))
                ? (_openBlock(), _createBlock(TryOnCameraFrame, { key: 0 }))
                : _createCommentVNode("", true),
              _createVNode(AllWorks)
            ], 2))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass({
          workspace: true,
          hidden: _unref(isAllWorksReady),
          'switch-instant': _unref(hasAlertShown)
        })
        }, [
          _createVNode(NewWorks, {
            ready: !initializing.value
          }, null, 8, ["ready"])
        ], 2)
      ]),
      _createVNode(Footer, {
        ready: !initializing.value,
        "is-loading": isLoading.value
      }, null, 8, ["ready", "is-loading"]),
      _createVNode(CAlert, {
        state: _unref(alertState),
        onClose: _unref(closeAlert),
        onConfirm: _unref(confirmAlert),
        onTriggerOtherAction: _unref(triggerOtherAction)
      }, null, 8, ["state", "onClose", "onConfirm", "onTriggerOtherAction"])
    ], 6),
    (loadingUsable.value)
      ? (_openBlock(), _createBlock(_Transition, {
          key: 0,
          name: "c-loading"
        }, {
          default: _withCtx(() => [
            (isLoading.value)
              ? (_openBlock(), _createBlock(CLoading, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})